import {RootStore} from './index';
import {makeAutoObservable} from "mobx"

export class UserStore {
    private rootStore: RootStore | undefined;
    public user= {
        id: 0
    };

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
        this.init();
    }

    init() {
        if (localStorage.getItem('users') !== null) {
            this.user = JSON.parse(String(localStorage.getItem('users')));
        }
    }

}